module.exports = __webpack_public_path__ + "static/img/yian-logo.4a279a87.png";